import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StaticMsgModule } from '@lib/pipes';
import { AnaBizApplicationListSubHeaderComponent } from './ana-biz-application-list-sub-header.component';
import { AnaBizApplicationListStoreModule } from '@common/store';

@NgModule({
  declarations: [AnaBizApplicationListSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, AnaBizApplicationListStoreModule],
  exports: [AnaBizApplicationListSubHeaderComponent],
})
export class AnaBizApplicationListSubHeaderModule {}
